export default __webpack_public_path__ + "static/media/edit-icon.4f64cec6.svg";